import type { IBaseCart } from "./types/IBaseCart";
import type { CartAttributes, ShopifyCartItemData } from "./types/ICartApi";
import type { ICartItem } from "./types/ICartItem";


export class CartItem implements ICartItem {

  private cart: IBaseCart;

  id: number;
  variantId: number;
  quantity: number;
  properties: CartAttributes;
  productId: number;
  key: string;
  title: string;
  price: number;
  linePrice: number;
  finalPrice: number;
  finalLinePrice: number;
  sku: string;
  grams: number;
  vendor: string;
  taxable: boolean;
  productHasOnlyDefaultVariant: boolean;
  giftCard: boolean;
  url: string;
  featuredImage: { url: string; aspectRatio: number; alt: null | string; } | null;
  image: string | null;
  handle: string;
  requiresShipping: boolean;
  productTitle: string;
  productDescription: string;
  productType: string;
  variantTitle: string;
  variantOptions: string[];
  optionsWithValues: { name: string; value: string; }[];

  constructor(cart: IBaseCart, data: ShopifyCartItemData) {
    this.cart = cart;

    this.id = data.id;
    this.variantId = data.variant_id;
    this.quantity = data.quantity;
    this.properties = data.properties;
    this.productId = data.product_id;
    this.key = data.key;
    this.title = data.title;
    this.price = data.price;
    this.linePrice = data.line_price;
    this.finalPrice = data.final_price;
    this.finalLinePrice = data.final_line_price;
    this.sku = data.sku;
    this.grams = data.grams;
    this.vendor = data.vendor;
    this.taxable = data.taxable;
    this.productHasOnlyDefaultVariant = data.product_has_only_default_variant;
    this.giftCard = data.gift_card;
    this.url = data.url;
    this.featuredImage = data.featured_image ? {
        url: data.featured_image.url,
        aspectRatio: data.featured_image.aspect_ratio,
        alt: data.featured_image.alt,
    } : null;
    this.image = data.image;
    this.handle = data.handle;
    this.requiresShipping = data.requires_shipping;
    this.productTitle = data.product_title;
    this.productDescription = data.product_description;
    this.productType = data.product_type;
    this.variantTitle = data.variant_title;
    this.variantOptions = data.variant_options;
    this.optionsWithValues = data.options_with_values;
  }
  
  changeQuantity(quantity: number): Promise<void> {
    return this.change(quantity, null);
  }
  changeProperties(properties: CartAttributes): Promise<void> {
    return this.change(null, properties);
  }
  change(quantity: null | number, properties: null | CartAttributes): Promise<void> {
    return this.cart.changeItem(this, quantity, properties);
  }
  remove(): Promise<void> {
    return this.cart.removeItem(this);
  }

}